import React from "react"
import { IDate, ISchedulePatternTemplate } from "../../../../../models"
import _ from "lodash"
import * as scheduleHelper from "../../../../../helpers/scheduleHelper"
import moment from "moment"
import * as positionHelper from "../../../../../helpers/positionHelper"
import { Card } from "material-ui"
import AppStateStore from "../../../../../stores/AppStateStore"

interface IProps {
    patternTemplates: ISchedulePatternTemplate[]
    //it's local time
    dayDate: IDate
    viewByEmployee?: boolean
    handleAssignEmployee(assignPatternTemplate: ISchedulePatternTemplate): void
    handleUnAssignEmployee(unAssignPatternTemplate: ISchedulePatternTemplate): void
}

const ScheduleResourcePlannerWeeklyDailyItem: React.SFC<IProps> = (props: IProps) => {
    let patternTemplatesForDay = scheduleHelper.getPatternTemplatesByDate(props.dayDate, props.patternTemplates)
        .filter((pt) => !pt.Deleted)
        .sort((a, b) => {
            if (a.AssignedUserId && b.AssignedUserId) return 0
            if (a.AssignedUserId < b.AssignedUserId) return -1
            if (a.AssignedUserId > b.AssignedUserId) return 1
        }).sort((a, b) => {
            if (a.AssignedUserName === b.AssignedUserName) return 0
            if (a.AssignedUserName < b.AssignedUserName) return -1
            if (a.AssignedUserName > b.AssignedUserName) return 1
        }).sort((a, b) => {
            if (!a.ShiftTemplates[0].Position && !b.ShiftTemplates[0].Position) return 0
            if (!a.ShiftTemplates[0].Position && b.ShiftTemplates[0].Position) return -1
            if (a.ShiftTemplates[0].Position && !b.ShiftTemplates[0].Position) return 1
            if (a.ShiftTemplates[0].Position.Name === b.ShiftTemplates[0].Position.Name) return 0
            if (a.ShiftTemplates[0].Position.Name < b.ShiftTemplates[0].Position.Name) return -1
            if (a.ShiftTemplates[0].Position.Name > b.ShiftTemplates[0].Position.Name) return 1
        })

    return (
        <Card style={{ flex: 1 }}>
            <div style={{ padding: 10, position: "relative" }} id="ScheduleViewPlace">
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "auto min-content",
                        position: "sticky",
                        top: AppStateStore.getTopBarHeight(),
                        zIndex: 10,
                        backgroundColor: "white"
                    }}
                >
                    <div style={{ gridColumn: 1 }}>
                        <div style={{ fontSize: 16, fontWeight: 700 }}>
                            {moment(props.dayDate).format("dddd")}
                        </div>
                        <div style={{ fontSize: 12, fontWeight: 500 }}>
                            {moment(props.dayDate).format("MM/DD/YY")}
                        </div>
                    </div>
                </div>
                {patternTemplatesForDay && patternTemplatesForDay.length > 0 &&
                    <div>
                        <table cellSpacing={0} cellPadding={3} style={{ fontSize: 11 }}>
                            {patternTemplatesForDay.map((row, index) => {
                                const positionColor = positionHelper.getPositionColorFromBasePositionId(row.ShiftTemplates[0].Position && row.ShiftTemplates[0].Position.BasePositionId)
                                const backgroundColor = scheduleHelper.getTransparentBackgroundColor(positionColor)
                                const fadeBackground = scheduleHelper.getTransparentBackgroundColorFade(positionColor, "#ffffff")
                                return (
                                    <tr key={index}>
                                        <td
                                            id={"schedule-row-item-" + row.Id}
                                            style={{
                                                gridRow: index,
                                                color: positionColor,
                                                whiteSpace: "nowrap",
                                                backgroundColor,
                                            }}
                                        >
                                            <div title={row.ShiftTemplates[0].Position ? row.ShiftTemplates[0].Position.Name : null}
                                                style={{
                                                    height: 8,
                                                    width: 8,
                                                    backgroundColor: positionColor,
                                                    borderRadius: "50%"
                                                }}
                                            >
                                            </div>
                                        </td>
                                        <td
                                            style={{
                                                gridRow: index,
                                                backgroundColor,
                                                whiteSpace: "nowrap",
                                                maxWidth: 100
                                            }}
                                        >
                                            <b>
                                                <span
                                                    className="TextOverflow"
                                                    style={{ display: "block" }}
                                                    title={row.AssignedUserName}
                                                >
                                                    {row.AssignedUserName}
                                                </span>
                                            </b>
                                            {row.AssignedUserExternalId &&
                                                <span
                                                    className="TextOverflow"
                                                    title={row.AssignedUserExternalId}
                                                    style={{ display: "block", color: "rgb(158, 158, 158)", fontSize: 10, marginTop: -5 }}
                                                >
                                                    Emp #: {row.AssignedUserExternalId}
                                                </span>
                                            }
                                            {row.ShiftTemplates[0].JobName &&
                                                <span
                                                    className="TextOverflow"
                                                    title={row.ShiftTemplates[0].JobName}
                                                    style={{ display: "block", color: "rgb(158, 158, 158)", fontSize: 10, marginTop: -5 }}
                                                >
                                                    Job: {row.ShiftTemplates[0].JobName}
                                                </span>
                                            }
                                        </td>
                                        <td style={{
                                            gridRow: index,
                                            backgroundColor,
                                        }}>
                                            {!row.AssignedUserId &&
                                                <i
                                                    className="fa fa-plus-circle"
                                                    style={{ fontSize: 14, cursor: "pointer" }}
                                                    onClick={() => props.handleAssignEmployee(row)}
                                                />
                                            }
                                            {row.AssignedUserId &&
                                                <i
                                                    className="fa fa-x"
                                                    style={{ fontSize: 14, cursor: "pointer" }}
                                                    onClick={() => props.handleUnAssignEmployee(row)}
                                                />
                                            }
                                        </td>
                                        <td
                                            style={{
                                                gridRow: index,
                                                backgroundColor,
                                                maxWidth: 30
                                            }}
                                        >
                                            {moment(scheduleHelper.getTimeFromSimpleTime(row.ShiftTemplates[0].StartTime)).format(row.ShiftTemplates[0].StartTime.Minute == 0 ? "ha" : "h:mma").slice(0, -1)}
                                        </td>
                                        <td
                                            style={{
                                                gridRow: index,
                                                background: fadeBackground,
                                                maxWidth: 30
                                            }}
                                        >
                                            {moment(scheduleHelper.getTimeFromSimpleTime(row.ShiftTemplates[0].EndTime)).format(row.ShiftTemplates[0].EndTime.Minute == 0 ? "ha" : "h:mma").slice(0, -1)}
                                        </td>
                                    </tr>
                                )
                            })}
                        </table>
                    </div>
                }
                {!patternTemplatesForDay || patternTemplatesForDay.length == 0 &&
                    <div style={{ textAlign: "center", padding: 30 }}><b>No Shifts</b></div>
                }
            </div>
        </Card>
    )
}

export default ScheduleResourcePlannerWeeklyDailyItem